var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_331","data-name":"Path 331","d":"M4.973,0,0,5.621l4.973,4.941","transform":"translate(5.68 11.27) rotate(180)","fill":"none","stroke":"#18404b","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1"}));
}

ArrowRight.defaultProps = {"width":"6.18","height":"11.976","viewBox":"0 0 6.18 11.976"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
